export const SITE_INSPECTION_GATE = "SITE_INSPECTION_GATE";
export const LOCATION_APPROVAL_PENDING = "LOCATION_APPROVAL_PENDING";
export const POC_LIST_BY_SITEID = "POC_LIST_BY_SITEID";
export const CHECK_LOCATION = "CHECK_LOCATION";
export const SITE_INSPECTION_GATE_SOLUTION = "SITE_INSPECTION_GATE_SOLUTION";
export const GATE_DETAIL = "GATE_DETAIL";
export const SITE_INSPECTION_CHECKLIST = "SITE_INSPECTION_CHECKLIST";
export const SITE_CARNIVAL_CHECKLIST = "SITE_CARNIVAL_CHECKLIST";
export const SITE_CARNIVAL_CHECKLIST_FILLED = "SITE_CARNIVAL_CHECKLIST_FILLED";
export const SITE_CONSUMABLE_ITEMS = "SITE_CONSUMABLE_ITEMS";

